import { ExternalLink } from '../../../icons';
import type { MediaEmbed } from '../../../lib/link-embed';

/**
 * MediaEmbedCard (chat-inline-media-playback — 2026-07-12) — YouTube/Vimeo/Spotify/SoundCloud
 * 단일 URL 메시지를 인라인 임베드 플레이어로 렌더. LinkPreviewCard 가 detectMediaEmbed 매칭 시
 * 이 카드로 분기하고, 미매칭이면 기존 도메인/OG 카드로 폴백(무회귀).
 *
 * 보안/개인정보:
 *   - src 는 detectMediaEmbed 화이트리스트 도메인만(임의 오리진 주입 불가).
 *   - referrerPolicy strict-origin, YouTube 는 nocookie 도메인.
 *   - 원문 링크 열기(footer)로 임베드 로드 실패(폐쇄망) 시에도 도달 경로 보존.
 */
export function MediaEmbedCard({ embed, href }: { embed: MediaEmbed; href: string }) {
  let host = '';
  try {
    host = new URL(href).host;
  } catch {
    host = '';
  }

  return (
    <div className={`chat-media-embed chat-media-embed--${embed.provider} is-${embed.kind}`}>
      <div className="chat-media-embed-frame-wrap">
        <iframe
          className="chat-media-embed-frame"
          src={embed.embedUrl}
          title={`${embed.provider} player`}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>
      <a
        className="chat-media-embed-open"
        href={href}
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        <ExternalLink size={13} aria-hidden />
        <span>{host || href}</span>
      </a>
    </div>
  );
}
